import { useEffect, useState } from "react";

export default function useElementVisibility(ref, options = {}) {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const el = ref?.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { root: null, threshold: 0.01, ...options }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, options.rootMargin, options.threshold]);
  return visible;
}
